import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Custom Pipes
import { SafeUrlPipe } from './safe-url/safe-url.pipe';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { ConvertCurrencyPipe } from './convertCurrency/convert-currency.pipe';
import { MaskStringPipe } from './mask-string/mask-string.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { CustomDatePipePipe } from './customDatePipe/custom-date-pipe.pipe';
import { Base64Pipe } from './base64/base64.pipe';
import { FilterOrderStatusPipe } from './filterOrderStatus/filter-order-status.pipe';
import { FormatTimePipe } from './formatTime/format-time.pipe';
import { FormatSitenamePipe } from './formatSitename/format-sitename.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SafeUrlPipe,
    CapitalizePipe,
    ConvertCurrencyPipe,
    MaskStringPipe,
    SafeHtmlPipe,
    CustomDatePipePipe,
    Base64Pipe,
    FilterOrderStatusPipe,
    FormatTimePipe,
    FormatSitenamePipe,
  ],
  exports: [
    SafeUrlPipe,
    CapitalizePipe,
    ConvertCurrencyPipe,
    MaskStringPipe,
    SafeHtmlPipe,
    CustomDatePipePipe,
    Base64Pipe,
    FilterOrderStatusPipe,
    FormatTimePipe,
    FormatSitenamePipe,
  ],
})
export class ApplicationPipesModule {}
